import './profile.css';

const Profile = () => {
  return (
    <>
      <p>PROFILE</p>
    </>
  );
};

export default Profile;
